module.exports = __webpack_public_path__ + "media/payment_icons/credit_card-4f56d81b.svg";